import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, makeStyles } from '@material-ui/core';
import { DiscapacidadBreadcrumb } from '../components/DiscapacidadBreadcrumb';
import { CargaCudLayout } from './layout/CargaCudLayout';
import { MENU_SOLICITUDES_CUD, STEPPER_INTEGRACION } from '../data/constants';
import { cleanSolicitudesDiscapacidadTomadas, getSolicitudesDiscapacidadTomadasPorUsuario, setActiveStepDiscapacidad, setAfiliadoSeleccionadoDiscapacidad, setBreadcrumbCud } from '../../../actions/discapacidad/discapacidadActions';
import { IntegracionIngresoHome } from './ingreso/IntegracionIngresoHome';
import { GestionIntegracionHome } from './gestionIntegracion/GestionIntegracionHome';
import { AdministrarSolicitudesIntegracion } from './components/AdministrarSolicitudesIntegracion';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
}));

export const HomeCud = (props) => {
  const dispatch = useDispatch();
  const classes = useStyles();

  const { activeBreadcrumb, solicitudSeleccionada, solicitudesTomadasUsuario } = useSelector((state) => state.discapacidad);
  const { permisos: permisosUser } = useSelector((state) => state.auth);

  useEffect(() => {
    if (props.location.state?.from === "/discapacidad/gestion" && solicitudSeleccionada) {
      dispatch(setBreadcrumbCud(MENU_SOLICITUDES_CUD.INGRESO_SOLICITUD));
      dispatch(setActiveStepDiscapacidad(STEPPER_INTEGRACION.DETALLES_ORDEN));
      dispatch(setAfiliadoSeleccionadoDiscapacidad(solicitudSeleccionada?.afiliado));

    } else {
      dispatch(cleanSolicitudesDiscapacidadTomadas());
      dispatch(getSolicitudesDiscapacidadTomadasPorUsuario());
      dispatch(setBreadcrumbCud(MENU_SOLICITUDES_CUD.DESELECCIONAR));
    }
  }, [props.location.state?.from, dispatch]);

  return (
    <div className={classes.root} >
      <Grid
        container
        spacing={1}
        direction="row"
        justify="center"
        alignItems="center"
      >
        <Grid item xs={12} styles={{ padding: 5 }}>
          <DiscapacidadBreadcrumb permisosUser={permisosUser} />
        </Grid>
        {!activeBreadcrumb && solicitudesTomadasUsuario.length > 0 &&
          <AdministrarSolicitudesIntegracion
            type={'currentUser'}
          />
        }
        {activeBreadcrumb === MENU_SOLICITUDES_CUD.INGRESO_SOLICITUD && (
          <IntegracionIngresoHome
            fromGestion={props.location.state?.from === "/discapacidad/gestion"}
          />
        )}
        {activeBreadcrumb === MENU_SOLICITUDES_CUD.GESTION_SOLICITUD && (
          <GestionIntegracionHome />
        )}
        {activeBreadcrumb === MENU_SOLICITUDES_CUD.CARGA_CUD &&
          <Grid item xs={11}>
            <CargaCudLayout />
          </Grid>
        }
        {/* {activeBreadcrumb === MENU_SOLICITUDES_CUD.DOCUMENTACION_GENERALIDADES &&
          <Grid item xs={11}>
            <DocumentacionGeneralidadesLayout />
          </Grid>
        } */}
      </Grid>
    </div>
  );
}
